module.exports = __webpack_public_path__ + "img/menu.1be0674c.svg";